import {actions as adminsActions, selectors as adminSelectors} from "../../../Ducks/admin";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import React, {useCallback, useMemo, useState} from "react";
import {BASE_URL, fetchPostWithoutBody} from "../../../API/util";
import {LoadingButton} from "@mui/lab";
import GridElement from "../../Common/GridElement";
import axios from "axios";
import Swal from "sweetalert2";

const ImportProfile = (props) => {
    const {loading, getProfilesImportList, profilesImportList} = props;
    const [btnLoading, setBtnLoading] = useState(false);
    const [cancelBtnLoading, setCancelBtnLoading] = useState(false);
    const [controlledPageIndex, setControlledPageIndex] = useState(0);
    const [filters, setFilters] = useState([]);
    const [inputKey, setInputKey] = useState(Date.now());
    const [selectedFile, setSelectedFile] = useState(null);
    const cols = useMemo(() => [
        {
            Header: 'File',
            accessor: 'import_file_name',
            column: 'import_file_name',
            minWidth: '160',
            filter: 'fuzzyText',
            Cell: ({row}) => (
                <a href={`${BASE_URL}/profiles-import/file/${row.original.import_id}/download`} target='_blank'>
                    {row.original.import_file_name}
                </a>
            ),
        },
        {
            Header: 'Status',
            accessor: 'import_status',
            column: 'import_status',
            minWidth: '150',
            filter: 'fuzzyText'
        },
        {
            Header: 'Uploaded By',
            accessor: 'created_by',
            column: 'created_by',
            minWidth: '150',
            filter: 'fuzzyText',
            Cell: ({row}) => (
                `${row.original.user_firstname} ${row.original.user_lastname}`
            ),
        },
        {
            Header: 'Created At',
            accessor: 'created_at',
            column: 'created_at',
            minWidth: '150',
            filter: 'fuzzyText'
        },
        {
            Header: 'Action',
            accessor: 'result',
            column: 'result',
            minWidth: '150',
            filter: 'fuzzyText',
            Cell: ({row}) => (
                row.original.import_status.toLowerCase() === 'completed' ?
                    <a href={`${BASE_URL}/profiles-import/report/${row.original.import_id}/download`} target='_blank'>
                        Download
                    </a> : row.original.import_status.toLowerCase() === 'pending' ?
                        <LoadingButton
                            variant="contained"
                            type='button'
                            loading={cancelBtnLoading}
                            size='small'
                            onClick={() => handleProfileImportCancellation(row.original.import_id)}>Cancel</LoadingButton> : ''
            ),
        },
    ], []);

    const handleProfileImportCancellation = async (importId) => {
        await setCancelBtnLoading(true);

        try {
            await fetchPostWithoutBody(`/profiles-import/cancel/${importId}`);
            await Swal.fire({
                icon: 'success',
                title: 'Import cancelled successfully!',
                showConfirmButton: false,
                timer: 1500
            })
        } catch (error) {
            return error;
        } finally {
            setBtnLoading(false);
            setInputKey(Date.now());
        }
    }

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setBtnLoading(true);

        if (!selectedFile) {
            alert('Please select a file first!');
            setBtnLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            await axios.post(`${BASE_URL}/profiles-import`, formData, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': undefined,
                }
            })
        } catch (error) {
            return error;
        } finally {
            setBtnLoading(false);

            await Swal.fire({
                icon: 'success',
                title: 'Uploaded successfully!',
                showConfirmButton: false,
                timer: 1500
            })

            setInputKey(Date.now());
        }
    };

    const fetchData = useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        const _columns = cols.filter(item => item.column !== 'result').map((item) => `profiles_import.${item.column}`);

        _columns.push('user_firstname', 'user_lastname');

        let query = "", api = "", sort = "", filterPrefix = "";

        filters.forEach((item, _index) => {
            const _filterColumn = columns.filter((column) => column.accessor === item.id);
            if (_filterColumn[0].column.includes(".")) {
                filterPrefix = _filterColumn[0].column.split(".")[0]
            } else {
                filterPrefix = "profiles_import"
            }
            query = query + `&contains[${filterPrefix}.${item.id}]=${item.value}`
        });

        //Check sorting
        if (sortBy.length) {
            let _sortByPrefix = "", _sortByColumn = columns?.filter((column) => column.accessor === sortBy[0].id);
            if (_sortByColumn[0]?.column.includes(".")) {
                _sortByPrefix = _sortByColumn[0].column.split(".")[0]
                _sortByPrefix = `${_sortByPrefix}.`
            }
            sort = `&sortBy=${sortBy[0].desc ? "-" : ""}${_sortByPrefix}${sortBy[0].id}`;
        }
        api = `results=${pageSize}&columns=${_columns}&offset=${pageIndex + 1}${query}${sort}`

        getProfilesImportList(api);
    }, [inputKey]);

    return (
        <>
            <div>
                <h2 className="page-title">Import Profiles</h2>
            </div>
            <div style={{marginTop: '30px', display: 'flex'}}>
                <h2 className="page-title" style={{fontSize: '20px'}}>Upload CSV</h2>
            </div>
            <div style={{display: 'flex'}}>
                <form onSubmit={handleSubmit}>
                    <input type="file" onChange={handleFileChange} key={inputKey}
                           style={{border: '1px solid #b8b0b0', padding: '5px', borderRadius: '2px'}}/>
                    <LoadingButton variant="contained" type='submit' style={{margin: '10px'}} loading={btnLoading}
                                   size='small'>Upload</LoadingButton>
                </form>
            </div>

            <GridElement
                loading={loading}
                columns={cols}
                data={profilesImportList?.main?.length ? profilesImportList?.main : []}
                fetchData={fetchData}
                pageCount={profilesImportList?.offset?.highest_offset}
                rowsCount={profilesImportList?.offset?.rows_count}
                filters={filters}
                setFilters={setFilters}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                initialSortBy="import_id"
                handleRowClick={() => {
                }}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    loading: adminSelectors.isLoading(state),
    profilesImportList: adminSelectors.profilesImportList(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getProfilesImportList: adminsActions.getProfilesImportList
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)((ImportProfile));